module.exports = __webpack_public_path__ + "static/OlenaPortnova-3d9af50ef05536529a07645a4a38aa40.jpeg";